module.exports = __webpack_public_path__ + "66abad0c85ecc9f7e8de9c30d7703913.svg";